module.exports = __webpack_public_path__ + "images/feature/20170912-1-e0409d4352a7fd698f5cd8e6f38ddfba.gif";